import React from 'react';

import { MapTo } from '@adobe/aem-react-editable-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './css/BreadCrumbNavigation.sass';

const BreadCrumbNavigation = ({ items }) => {
  if (!items || !items.length) return null;

  return (
    <div className="layout-outer-container">
      <div className="bread-crumb-container">
        <ul className="bread-crumb-list">
          {items.map((crumb, index) => (
            <li key={`${crumb}-${index}`} className="bread-crumb-list-element">
              <Link to={{ pathname: crumb.url }}>
                {crumb.title}
                <span className="chevron right" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
BreadCrumbNavigation.propTypes = {
  items: PropTypes.array.isRequired,
};
MapTo('e-fix/components/structure/breadcrumb')(BreadCrumbNavigation);
